import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'Once closed, you will no longer be able to take any action on your account.\nClosing your Shine account does not mean closing your business, this formality must be done on your side.',
    clickHere: 'Click here',
    closeMyAccount: 'Permanently close my account',
    help: 'You would like to know how to close your business? ',
    keepMyAccount: 'Keep my account',
    title: 'Are you sure you want to close your Shine account?',
  },
  fr: {
    body: 'Une fois clôturé, vous ne pourrez plus effectuer aucune action sur votre compte.\n\nLa clôture de votre compte Shine n’entraine pas la fermeture de votre entreprise, cette formalité doit être effectuée de votre côté.',
    clickHere: 'Cliquez ici',
    closeMyAccount: 'Clôturer mon compte définitivement',
    help: 'Vous souhaitez connaître les démarches pour cesser votre activité ? ',
    keepMyAccount: 'Garder mon compte',
    title: 'Êtes-vous sûr·e de vouloir clôturer votre compte Shine ?',
  },
});

export default locales;
